import { ROLE_LIST_START, ROLE_LIST_SUCCESS, ROLE_LIST_FAIL } from './constants';

export const roleListReducer = (
  state = {
    items: [],
    fetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case ROLE_LIST_START:
      return { ...state, fetching: true };
    case ROLE_LIST_SUCCESS:
      return { ...state, fetching: false, items: action.payload };
    case ROLE_LIST_FAIL:
      return { ...state, fetching: false, error: action.payload };
    default:
      return state;
  }
};
